import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { getName } from "../Actions";
import { updateDoc, doc } from "firebase/firestore";
import { db } from "../firebase";
import { useUsers } from "../UserContext";
import { toast } from "react-hot-toast";

function EditProfile(props) {
  const [userId, setUserId] = useState("");
  const { fetchUsers } = useUsers();

  useEffect(() => {
    setUserId(localStorage.getItem("user_id"));
  }, []);
  const [saving, setSaving] = useState(false);

  const [updatedUser, setUpdatedUser] = useState(props.user);

  function handleChange(e) {
    setUpdatedUser({
      ...updatedUser,
      [e.target.name]: e.target.value,
    });
  }

  const saveProfile = async (e) => {
    e.preventDefault();
    if (!(updatedUser.first_name || "").trim()) {
      toast.error("First name can't be empty.");
      return;
    }
    setSaving(true);
    try {
      await updateDoc(doc(db, 'users', userId), {
        first_name: (updatedUser.first_name || "").trim(),
        last_name: (updatedUser.last_name || "").trim(),
        city: updatedUser.city || "",
        state: updatedUser.state || "",
        country: updatedUser.country || "",
        bio: updatedUser.bio || "",
      });
      await fetchUsers();
      props.getName(userId);
      toast.success("Profile saved!");
      props.setEditProfile(false);
    } catch (err) {
      console.error("Failed to save profile:", err);
      toast.error("Could not save your profile. Please try again.");
    } finally {
      setSaving(false);
    }
  };

  return (
    <div>
      <form>
        <div className="roundedbox">
          <p className="profiletext">
            <label htmlFor="first_name">
              <b>Name:</b>
            </label>
            <br />
            <input
              id="first_name"
              type="text"
              name="first_name"
              value={updatedUser.first_name || ""}
              placeholder="First name"
              onChange={handleChange}
            />
            <br />
            <input
              type="text"
              name="last_name"
              value={updatedUser.last_name || ""}
              placeholder="Last name"
              onChange={handleChange}
            />
          </p>
        </div>
        <div className="roundedbox">
          <p className="profiletext">
            <b>Location:</b>
            <br />
            <input
              id="city"
              type="text"
              name="city"
              value={updatedUser.city || ""}
              placeholder="City"
              onChange={handleChange}
            />
            <br />
            <input
              id="state"
              type="text"
              name="state"
              value={updatedUser.state || ""}
              placeholder="State"
              onChange={handleChange}
            />
            <br />
            <input
              id="country"
              type="text"
              name="country"
              value={updatedUser.country || ""}
              placeholder="Country"
              onChange={handleChange}
            />
          </p>
        </div>
        <div className="roundedbox">
          <p className="profiletext">
            <b>Bio:</b>
            <br />
            <textarea
              id="bio"
              type="text"
              name="bio"
              value={updatedUser.bio || ""}
              onChange={handleChange}
            />
          </p>
        </div>
        <button type="submit" className="brownroundbutton" onClick={saveProfile} disabled={saving}>
          {saving ? "Saving…" : "Save Profile"}
        </button>
        <button type="button" className="brownroundbutton" onClick={() => props.setEditProfile(false)} style={{ marginLeft: "10px" }}>
          Cancel
        </button>
      </form>
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    first_name: state.first_name,
    last_name: state.last_name,
    profile_pic_url: state.profile_pic_url,
    profile_pic_alt: state.profile_pic_alt,
  };
};

export default connect(mapStateToProps, { getName })(EditProfile);
